import {ProductServiceRepository} from "./product-service.repository";
import {ProductServiceRepositoryV2} from "./product-service.repository.v2";

export type {ProductServiceRepository} from "./product-service.repository";
export {ProductServiceRepositoryV2} from "./product-service.repository.v2";

/**
 * Creates the ProductServiceRepository. V1 has been fully retired — this
 * always returns the v2 implementation.
 *
 * @example
 * const repository = createProductServiceRepository();
 * const service = await repository.getSingle(123);
 */
export const createProductServiceRepository = (): ProductServiceRepository => {
  return new ProductServiceRepositoryV2();
};
